import { action, computed, observable, makeObservable } from 'mobx';
import {XMediaStreamTrackState} from '../models';

export class MediaStreamTrackStateStore {
  @observable
  muted: boolean = false;
  @observable
  live: boolean = false;
  @observable
  ended: boolean = false;

  constructor(readonly track: MediaStreamTrack) {
    makeObservable(this);
    this.updateState();
    track.onmute = this.updateState;
    track.onended = this.updateState;
    track.onunmute = this.updateState;
  }

  @action
  updateState = () => {
    const track = this.track;
    this.muted = track.muted;
    this.live = track.readyState === 'live';
    this.ended = track.readyState === 'ended';
  };

  @computed
  get state(): XMediaStreamTrackState {
    return {
      muted: this.muted,
      live: this.live,
      ended: this.ended
    };
  }

  dispose = () => {
    const track = this.track;
    track.onmute = null;
    track.onended = null;
    track.onunmute = null;
  };
}
